module.exports = __webpack_public_path__ + "static/media/Python_Version_I-Won.79903050.gif";